"use strict";

require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.weak-map.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _drei = require("@react-three/drei");
var _reactRedux = require("react-redux");
var _leva = require("leva");
var _three = require("three");
var _reactErrorBoundary = require("react-error-boundary");
var _selectors = require("../../../redux/selectors");
var _paulCorePackage = require("paul-core-package");
var _constants = require("../../../utils/constants");
const _excluded = ["debug", "onPointerOver", "onClick", "onPointerMissed", "onPointerOut", "position"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const SensorModelContent = props => {
  const {
      debug = {},
      onPointerOver,
      onClick,
      onPointerMissed,
      onPointerOut,
      position = [-0.8, 0, 0]
    } = props,
    p = _objectWithoutProperties(props, _excluded);
  const SensorModelRef = (0, _react.useRef)(null);
  const {
    source
  } = (0, _reactRedux.useSelector)(_paulCorePackage.selectors.getUrls);
  const {
    nodes,
    materials
  } = (0, _drei.useGLTF)("".concat(source).concat(_constants.webGLModalsSource, "/100_paul_assets/101_paul_sensor.glb"));
  const [showHelper, setShowHelper] = (0, _react.useState)(false);
  const [showItem, setShowItem] = (0, _react.useState)(true);
  const shadows = {
    castShadow: true,
    receiveShadow: false
  };
  const debugModeStatus = (0, _reactRedux.useSelector)(_selectors.getDebugModeStatus);
  const {
    name = 'SensorModel',
    showDebug = false
  } = debug;

  // const {helper, display, ...controlP} = useControls(
  //     name, {...p, helper: showHelper, display: showItem}, {collapsed: true}
  // );
  // useEffect(() => {
  //     setShowHelper(showDebug && helper)
  // }, [helper, showDebug])
  //
  // useEffect(() => {
  //     setShowItem(display)
  // }, [display])
  //
  // useHelper(debugModeStatus && showHelper && SensorModelRef, BoxHelper, 'blue')

  return (0, _react.useMemo)(() => /*#__PURE__*/_react.default.createElement("group", _extends({
    position: position,
    dispose: null,
    visible: true,
    ref: SensorModelRef
  }, p), /*#__PURE__*/_react.default.createElement("mesh", {
    position: [0, 0, 0]
  }, /*#__PURE__*/_react.default.createElement("boxGeometry", {
    args: [40, 40, 40]
  }), /*#__PURE__*/_react.default.createElement("meshStandardMaterial", {
    color: "#FF0000",
    transparent: "true",
    opacity: ".0",
    alphaTest: true
  })), /*#__PURE__*/_react.default.createElement("group", {
    onPointerOver: onPointerOver,
    onClick: onClick,
    onPointerMissed: onPointerMissed,
    onPointerOut: onPointerOut
  }, /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['01_base'].geometry,
    material: materials['Component.SensorBase'],
    position: [1, 0, 0],
    rotation: [0, 0, -Math.PI / 2]
  }, shadows)), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['02_cover'].geometry,
    material: materials['Component.SensorBase'],
    position: [2.77, 0, 0],
    rotation: [0, 0, -Math.PI / 2]
  }, shadows)), /*#__PURE__*/_react.default.createElement("mesh", _extends({
    geometry: nodes['03_paul_logo'].geometry,
    material: materials['Component.EmissionBlau'],
    position: [2.17, 0.9, 0.08],
    rotation: [Math.PI / 2, 0, -Math.PI / 2]
  }, shadows)))), [position, p, nodes, materials, shadows]);
};

// useGLTF.preload('/101_paul_sensor.glb')
const SensorModel = (0, _reactErrorBoundary.withErrorBoundary)(SensorModelContent, {
  FallbackComponent: () => null,
  onError: (err, info) => console.error(err, info)
});
var _default = exports.default = SensorModel;